(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.jaJp = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    search: {
      placeholder: 'Search'
    },
    menuToggle: {
      label: 'メニュー'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: '製品デモ',
      classes: 'btn-ghost hidden-xs gold',
      link: '/resources/expense-demo'
    }, {
      text: 'ログイン',
      classes: 'btn-ghost hidden-xs concur-blue',
      link: ''
    }],
    loginLink: {
      text: 'ログイン',
      src: ''
    },
    siteLinks: [{
      title: {
        text: '製品'
      },
      list: [{
        text: '経費精算',
        src: '/expense-management'
      }, {
        text: '出張手配',
        src: '/travel-booking'
      }, {
        text: '請求書管理',
        src: '/invoice-management'
      }, {
        text: '分析レポート',
        src: '/business-intelligence'
      }, {
        text: '出張者のリスク管理',
        src: '/risk-messaging'
      }, {
        text: 'モバイル',
        src: '/expense-mobile'
      }, {
        text: '製品デモを見る',
        src: '/resources/expense-demo',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'ソリューション'
      },
      list: [{
        text: '出張手配と経費精算の統合',
        src: '/travel-expense'
      }, {
        text: '交通系ICカード（Suica等）連携',
        src: '/newsroom/video/03-02-2017'
      }, {
        text: 'オープンプラットフォーム',
        src: '/concur-integrated-ecosystem'
      }, {
        text: '中堅・中小企業向け',
        src: '/perfect-expense'
      }, {
        text: '電子帳簿保存法対応',
        src: '/electronic-book-act'
      }, {
        text: '見積もり依頼',
        classes: 'call-out',
        src: '/get-quote-form'
      }]
    }, {
      title: {
        text: '会社情報'
      },
      list: [{
        text: '会社概要',
        src: '/about'
      }, {
        text: '会社沿革',
        src: '/history'
      }, {
        text: 'リーダーシップ',
        src: '/leadership'
      }, {
        text: '人材採用',
        src: '/jobs'
      }, {
        text: 'CSR活動',
        src: '/about/corporate-responsibility'
      }, {
        text: 'サポート',
        src: '/support'
      }, {
        text: '問い合わせ',
        classes: 'call-out',
        src: '/contact'
      }]
    }, {
      title: {
        text: 'お役立ち情報'
      },
      list: [{
        text: 'プレスリリース',
        src: '/newsroom/t/press-release'
      }, {
        text: '最新ニュース',
        src: '/newsroom'
      }, {
        text: 'イベント & セミナー',
        src: '/events'
      }, {
        text: '導入事例',
        src: '/casestudy/index'
      }, {
        text: '資料ダウンロード',
        src: '/resource-center'
      }, {
        text: 'パートナー',
        src: '/partners'
      }, {
        text: 'App Center',
        src: '/app-center'
      }, {
        text: 'モバイルアプリ',
        src: '/mobile'
      }]
    }],
    supportLinks: [{
      text: 'ブログ',
      href: '/newsroom'
    }, {
      text: '問い合わせ',
      href: '/contact'
    }, {
      text: '見積もり依頼 ',
      href: '/get-quote-form'
    }, {
      text: 'サービス稼働状況',
      href: ''
    }],
    mobileAppText: {
      text: 'モバイルアプリをダウンロード'
    }
  };
});